<template>
  <div>
    <div class="down">
      <el-button type="primary" @click="finishDesign">完成设计</el-button>
      <el-button @click="cancelDesign">取消</el-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    finishDesign() {
      this.$emit("finishDesign");
    },
    cancelDesign() {
      // 取消设计的逻辑处理
      this.$emit("designCancelled");
    }
  }
};
</script>

<style>
.down {
  position: absolute;
  bottom: 40px;
  left: calc(40% - 200px);
  width: 500px;
  overflow-x: auto;
  height: 50px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  z-index: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  z-index: 4;
  width: 200px;
  background: rgba(0, 0, 0, 0.68);
  .operButton {
    width: 60px;
    padding: 0 10px;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .mark {
      width: 5px;
      height: 5px;
      position: absolute;
      bottom: 12px;
      right: 5px;
      cursor: pointer;
    }
  }
}
</style>
